import { PanelLeftClose, PanelLeft } from "lucide-react";
import IHLogoLarge from "src/images/logos/inhouse-logo-large.png";

const SideNavHeader = ({ sidenavCollapsed, onHideMobileSideNav, onLogoClick, onChangeSidenavCollapse }) => {
  return (
    <div className="flex items-center justify-between">
      {sidenavCollapsed ? (
        <button
          className="w-[32px] h-[32px] rounded-full border border-[#E5E5E5] flex items-center justify-center hover:bg-gray-50 transition-colors mx-auto cursor-pointer"
          onClick={onChangeSidenavCollapse}
        >
          <PanelLeft size={16} className="text-[#0F0F0F]" />
        </button>
      ) : (
        <>
          <img
            src={IHLogoLarge}
            className="w-[100px] h-[21px] object-contain cursor-pointer"
            alt="Inhouse"
            draggable={false}
            onClick={onLogoClick}
          />
          <button
            className="w-[32px] h-[32px] rounded-full border border-[#E5E5E5] flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
            onClick={() => {
              if (window.innerWidth < 768) {
                onHideMobileSideNav();
              } else if (onChangeSidenavCollapse) {
                onChangeSidenavCollapse();
              }
            }}
          >
            <PanelLeftClose size={16} className="text-[#0F0F0F]" />
          </button>
        </>
      )}
    </div>
  );
};

export default SideNavHeader;
